import { render, staticRenderFns } from "./ManageEquipments.vue?vue&type=template&id=3b97e7c2&"
import script from "./ManageEquipments.vue?vue&type=script&lang=js&"
export * from "./ManageEquipments.vue?vue&type=script&lang=js&"
import style0 from "./ManageEquipments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports